import { render, staticRenderFns } from "./TeacherWorkGroupByCourse.vue?vue&type=template&id=be0ec364&scoped=true"
import script from "./TeacherWorkGroupByCourse.vue?vue&type=script&lang=js"
export * from "./TeacherWorkGroupByCourse.vue?vue&type=script&lang=js"
import style0 from "./TeacherWorkGroupByCourse.vue?vue&type=style&index=0&id=be0ec364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0ec364",
  null
  
)

export default component.exports